/* ==========================================================================
   Meru House — "You may also like" row (sections/mh-also-like.liquid)

   First paint: the section already holds the product's metafield picks
   (sold-out / current product removed, multi-size first).
   Here we fetch Shopify's related recommendations through the Section
   Rendering API, merge them in after the picks, de-duplicate, and re-apply
   the rules:
     order  = picks (2+ sizes), recs (2+ sizes), picks (1 size), recs (1 size)
     limit  = data-max (4)
     < 2    = hide the section, and hide the one-off "see similar styles" note
   Card add-to-bag is handled by mh-card.js (document-level delegation), so
   injected cards work without re-binding.
   ========================================================================== */
(function () {
  if (window.__mhAlsoLikeInit) return;
  window.__mhAlsoLikeInit = true;

  function setNotes(visible) {
    var notes = document.querySelectorAll('[data-mh-oneoff-note]');
    for (var i = 0; i < notes.length; i++) notes[i].hidden = !visible;
  }

  function finalize(root, list, items) {
    var max = parseInt(root.getAttribute('data-max'), 10) || 4;
    var current = root.getAttribute('data-product-id');
    var seen = {};
    seen[current] = true;

    var unique = [];
    items.forEach(function (li) {
      var pid = li.getAttribute('data-pid');
      if (!pid || seen[pid]) return;
      seen[pid] = true;
      unique.push(li);
    });

    function bucket(src, multi) {
      return unique.filter(function (li) {
        var n = parseInt(li.getAttribute('data-sizes'), 10) || 0;
        return li.getAttribute('data-src') === src && (multi ? n >= 2 : n < 2);
      });
    }

    var ordered = []
      .concat(bucket('pick', true), bucket('rec', true), bucket('pick', false), bucket('rec', false))
      .slice(0, max);

    list.replaceChildren.apply(list, ordered);

    var show = ordered.length >= 2;
    root.hidden = !show;
    root.setAttribute('data-count', String(ordered.length));
    setNotes(show);
  }

  function init(root) {
    if (root.__mhInit) return;
    root.__mhInit = true;

    var list = root.querySelector('[data-mh-al-list]');
    if (!list) return;
    var picks = Array.prototype.slice.call(list.querySelectorAll(':scope > [data-mh-al-item]'));
    var max = parseInt(root.getAttribute('data-max'), 10) || 4;

    var allPicksMulti = picks.every(function (li) {
      return (parseInt(li.getAttribute('data-sizes'), 10) || 0) >= 2;
    });
    if (picks.length >= max && allPicksMulti) {
      finalize(root, list, picks);
      return;
    }

    fetch(root.getAttribute('data-url'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var recs = [];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          recs = Array.prototype.slice.call(doc.querySelectorAll('[data-mh-al-list] > [data-mh-al-item]'));
          recs = recs.map(function (li) { return document.importNode(li, true); });
        }
        finalize(root, list, picks.concat(recs));
      })
      .catch(function () {
        finalize(root, list, picks);
      });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-mh-also-like]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  // Smooth-scroll for the one-off note link.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-mh-oneoff-link]');
    if (!link) return;
    var target = document.getElementById('mh-also-like');
    if (!target || target.hidden) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', boot);
})();
